export default __webpack_public_path__ + "static/media/smardtv_thumbnail.cd64573a.png";